<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
  >
    <path d="M8.5 6.5C8.5 6.68008 8.40317 6.84624 8.24651 6.93502L5.61976 8.42351C5.11978 8.70683 4.5 8.34566 4.5 7.77099V5.22907C4.5 4.6544 5.11977 4.29323 5.61975 4.57654L8.2465 6.06499C8.40317 6.15377 8.5 6.31993 8.5 6.5ZM6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5ZM1 6.5C1 3.73858 3.23858 1.5 6 1.5C8.76142 1.5 11 3.73858 11 6.5C11 9.26142 8.76142 11.5 6 11.5C3.23858 11.5 1 9.26142 1 6.5Z" />
  </svg>
</template>
